document.addEventListener("DOMContentLoaded", function(event) {
  

//add document click bubble event to identify any quick view buttons that might have been dynamically invented 
document.addEventListener('click',function(e){
  if(e.target.classList.contains('quick-view')){
    e.preventDefault();
    let clickedHandle = e.target.getAttribute("data-handle");
    if(clickedHandle != null){
     launchQuickViewModal(clickedHandle); 
    }
  }
});



// Select the modal element
const quickview_modal = document.getElementById("quickview-modal");


function launchQuickViewModal(handle){
  
  // Select the container in the modal where we'll display the product details
  const modalContent = quickview_modal.querySelector(".modal-content");
  
  //clear out any exisiting modal content
  modalContent.innerHTML = '';
  
  // Fetch the product data from Shopify and populate the modal with the product details
  fetch(`/products/${handle}?view=quickview`)
    .then(response => response.json())
    .then(product => {



      //create div structure
      const outerWrapper = document.createElement("div");
      outerWrapper.classList.add('columns');

      const imageDiv = document.createElement("div");
      imageDiv.classList.add('column','is-4');

      const contentDiv = document.createElement("div");

      const title = document.createElement('h2')
      title.classList.add('header','is-size-4','heading','has-text-centered')
      title.innerHTML = product.title;
      title.style.color = "black"

      modalContent.appendChild(title);

      modalContent.appendChild(outerWrapper);
      outerWrapper.append(imageDiv, contentDiv);
      
  
      // Create an image element and set its source to the product image
      const productImage = document.createElement("img");

      //turn images string into array
      let product_images = product.images.split(',');

      //get image with master in the url
      let masterFound = product_images.find(str => str.includes('.master'));
      let image_path = '';
      if(masterFound){
        image_path = masterFound;
      }else{
        image_path = product_images[0];
      }

      productImage.style.maxHeight = "40vh";
      productImage.src = `//www.80stees.com/cdn/shop/${image_path}`;
      imageDiv.appendChild(productImage);

      imageDiv.style.display = "flex";
      imageDiv.style.justifyContent = "center";
      const fieldDiv = document.createElement("div");
      fieldDiv.classList.add('field', 'has-addons');
      const controlDiv = document.createElement("div");
      controlDiv.classList.add('control', 'is-expanded');
      const controlDivTwo = document.createElement("div");
      controlDivTwo.classList.add('control');
      const selectDiv = document.createElement("div");
      selectDiv.classList.add('select', 'is-large', 'is-fullwidth');
      contentDiv.appendChild(fieldDiv);
      fieldDiv.appendChild(controlDiv);
      fieldDiv.appendChild(controlDivTwo);
      controlDiv.appendChild(selectDiv);
      

      // Create a select element for the product variants and add options for each variant
      const variantSelect = document.createElement("select");
      variantSelect.name = "variants";
      variantSelect.id = "variants-select";
      product.variants.forEach(variant => {
        const option = document.createElement("option");
        option.value = variant.id;
        option.dataset.price = variant.price;
        option.dataset.original_price = variant.original_price;
        option.text = variant.title;
        variantSelect.appendChild(option);
      });
      selectDiv.appendChild(variantSelect);
  
      // Create a button for adding the selected variant to the cart and add an event listener to handle the click
      const addToCartButton = document.createElement("button");
      addToCartButton.textContent = "Add to Cart";
      addToCartButton.classList.add('button','is-large', 'is-primary');
      addToCartButton.addEventListener("click", () => {
        // Get the selected variant ID from the select element
        const selectedVariantId = variantSelect.value;
  
        // Use the Shopify AJAX API to add the product variant to the cart
        // Replace "variant_id" and "quantity" with the actual values for your product variant and quantity
        const variantId = selectedVariantId;
        const quantity = 1;
        //close quickview modal
        quickview_modal.classList.remove("is-active");
        document.documentElement.classList.remove('freeze-frame');
        
        // Set up the fetch request
        fetch(`//www.80stees.com/cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(response => {
          // Handle the response from Shopify
          if (response.ok) {
            if (typeof window.v_markRecentCartActivityForHomeReminder === 'function') {
              window.v_markRecentCartActivityForHomeReminder();
            }
            // The item was successfully added to the cart
            window.openCartDrawer();
          } else {
            // There was an error adding the item to the cart
            console.error("Error adding item to cart.");
          }
        })
        .catch(error => {
          // Handle any errors that occur during the fetch request
          console.error(error);
        });

        
      });

      controlDivTwo.appendChild(addToCartButton);
    });
    
    //now show the modal
    quickview_modal.classList.add("is-active");
    document.documentElement.classList.add('freeze-frame');
    //close cart if it is open
    window.closeCartDrawer()

    // Add an event listener to the modal to close it when the user clicks the close button or clicks outside the modal
    quickview_modal.addEventListener("click", event => {
      const target = event.target;
      if (target.classList.contains("modal-close") || target.classList.contains("modal-background")) {
        quickview_modal.classList.remove("is-active");
        document.documentElement.classList.remove('freeze-frame');
      }
    });

}


  
});